import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from "chart.js";
import { Button } from "flowbite-react";
import React, { useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import { FaBullhorn, FaDollarSign, FaEdit, FaSave } from "react-icons/fa";
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);



const PostProductionAnalysis = () => {

  const budgetData = {
    labels: ["Distributor A", "Promotions", "Location Travel", "Distributor D", "Distributor E"],
    datasets: [
      {
        label: "Budget ($ millions)",
        data: [50, 30, 35, 15, 10],
        backgroundColor: ["#4CAF50", "#FFEB3B", "#2196F3", "#FF5722", "#9C27B0"],
        borderColor: ["#4CAF50", "#FFEB3B", "#2196F3", "#FF5722", "#9C27B0"],
        borderWidth: 1,
      },
    ],
  };

  const promotionsData = {
    labels: ["Digital Marketing", "Social Media Campaigns", "Influencer Partnerships", "Event Promotions"],
    datasets: [
      {
        label: "Budget ($ millions)",
        data: [10, 7, 5, 8],
        backgroundColor: ["#FF5722", "#4CAF50", "#FFEB3B", "#2196F3"],
        borderColor: ["#FF5722", "#4CAF50", "#FFEB3B", "#2196F3"],
        borderWidth: 1,
      },
    ],
  };

  const [listItems, setListItems] = useState([
    { id: 1, text: "Distributor A: $50 million" },
    { id: 2, text: "Promotions: $30 million" },
    { id: 3, text: "Location travel: $35 million" },
    { id: 4, text: "Distributor D: $15 million" },
    { id: 5, text: "Distributor E: $10 million" },
  ]);

  const [editId, setEditId] = useState(null); 
  const [editText, setEditText] = useState(''); 

  const handleEdit = (id, text) => {
    setEditId(id); 
    setEditText(text);
  };

  const handleSave = (id) => {
    setListItems(listItems.map(item => 
      item.id === id ? { ...item, text: editText } : item
    ));
    setEditId(null);
  };

  // State and handlers for editing the remaining funds
  const [remainingFunds, setRemainingFunds] = useState(120); // Initial remaining funds
  const [isEditingFunds, setIsEditingFunds] = useState(false);
  const [fundsInput, setFundsInput] = useState(remainingFunds);

  const handleEditFunds = () => {
    setIsEditingFunds(true);
  };

  const handleSaveFunds = () => {
    setRemainingFunds(fundsInput);
    setIsEditingFunds(false);
  };

  return (
    <>
    <SEO
      title="Post-Production Analysis"
      description="Analyse your film's post-production market data including streaming performance, audience metrics, and distribution insights on ProducerBuddy."
      url="https://producerbuddy.pilomation.com/post-production-analysis"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className=" p-4 pl-0">
      <h2 className="text-4xl font-bold text-center mb-10">Post-Production Market Analysis</h2>
      <div className="flex justify-between items-center">
        <div className="flex items-center bg-yellow-600 rounded-md text-white p-2">
          {isEditingFunds ? (
            <div className="flex items-center">
              <input 
                type="number" 
                value={fundsInput} 
                onChange={(e) => setFundsInput(e.target.value)} 
                className="text-black w-24 mr-2 p-1"
              />
              <button onClick={handleSaveFunds} className="p-2 text-green-600"><FaSave /></button>
            </div>
          ) : (
            <>
              <span>Remaining funds: ${remainingFunds} million</span>
              <button onClick={handleEditFunds} className="ml-2 p-2">
                <FaEdit className="text-blue-600" />
              </button>
            </>
          )}
        </div>
        <Link to='/market-analysis'>
          <Button className="bg-green-600 text-white py-2 px-4 rounded">Manage & get new findings</Button>
        </Link>
      </div>

      <div className="flex gap-4 mt-4">
        <div className="bg-white p-6 w-50 rounded-lg mb-6 gap-4 flex flex-col">
          {/* Budget Analysis Section */}
          <div className="w-100 ">
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <FaDollarSign className="mr-2" /> Budget Analysis for Distribution
            </h2>
            <p className="text-gray-700 mb-4">
              Understanding how the budget is allocated for various aspects of distribution is essential to ensure a profitable release.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <div>
                <p className="font-semibold text-left">Add or update budgets:</p>
              </div>
            {listItems.map((item) => (
              <li key={item.id} className="relative group">
                {editId === item.id ? (
                  <div className="flex items-center">
                    <input 
                      type="text" 
                      value={editText} 
                      onChange={(e) => setEditText(e.target.value)} 
                      className="border border-gray-400 rounded px-2 py-1 mr-2" 
                    />
                    <button onClick={() => handleSave(item.id)} className="p-2 text-green-600">
                      <FaSave />
                    </button>
                  </div>
                ) : (
                  <>
                    <span style={{ fontWeight: 'normal', fontSize: '14px', cursor:'pointer' }}  onMouseEnter={(e) => {
                            e.target.style.fontWeight = 'bold';
                            e.target.style.fontSize = '14px';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.fontWeight = 'normal';
                            e.target.style.fontSize = '14px';
                          }}>
                      {item.text}
                    </span>
                    <button 
                      onClick={() => handleEdit(item.id, item.text)} 
                      className="absolute right-0 top-0 p-2 opacity-1 group-hover:opacity-100 transition-opacity duration-300"
                      style={{ display: 'inline-block' }}
                    >
                      <FaEdit className="text-blue-600" />
                    </button>
                  </>
                )}
              </li>
            ))}
          </ul>

          </div>
          
          <div className="mt-4 p-4 bg-gray-50 border rounded-lg">
            <h3 className="text-xl font-semibold mb-2">Detailed Distribution Budget Breakdown</h3>
            <p className="text-gray-600">
              Distributor A leads with a higher budget due to their focus on global release strategies, particularly in North America
              and Europe. Smaller distributors tend to concentrate on regional markets, with lower budgets but higher localized returns.
            </p>
          </div>
          <Pie data={budgetData} />
        </div>

        {/* Promotions Management Section */}
        <div className="bg-white p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-4 flex items-center">
            <FaBullhorn className="mr-2" /> Managing Promotions and Marketing Campaigns
          </h2>
          <p className="text-gray-700 mb-4">
            Promotions play a key role in post-production success. They help generate excitement for the movie and ensure maximum
            audience engagement.
          </p>
          <div className="mt-4 p-4 bg-gray-50 border rounded-lg">
            <h3 className="text-xl font-semibold mb-2">Promotional Strategies</h3>
            <p className="text-gray-600">
              Analyzing budget allocation is crucial to optimizing distribution strategies and ensuring a profitable release. This section provides insights into the financial breakdown.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li><strong>Digital Marketing:</strong> $10 million</li>
              <li><strong>Social Media Campaigns:</strong> $7 million</li>
              <li><strong>Influencer Partnerships:</strong> $5 million</li>
              <li><strong>Event Promotions:</strong> $8 million</li>
            </ul>
          </div>
          <Bar data={promotionsData} />
        </div>
      </div>
    </div>
    </>
    
  );
};

export default PostProductionAnalysis;

